import { FC, useContext, useEffect, useLayoutEffect } from "react";
import { useParams } from "react-router-dom";
import FooterText from "src/components/footerText";
import useFetch from "src/hooks/useFetch";
import { LoaderContext } from "src/context/loaderContext";
import { EOBsDetailAPIResponseType } from "./types";
import { APIEndpoints } from "src/types/apiTypes";
import AuthSubHeader from "../../components/authSubHeader";
import EOBsInformation from "src/components/EOBsInformation";


const EOBsDetail: FC = (): JSX.Element => {
  const { id } = useParams();
    const { setLoader, hideLoader } = useContext(LoaderContext);


  useLayoutEffect(()=>{
      setLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

  const { data: uploadEOBsObject } =
    useFetch<EOBsDetailAPIResponseType>(APIEndpoints.EOBs_DETAIL, {}, { id });

  useEffect(() => {
    if (uploadEOBsObject) {
      hideLoader();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadEOBsObject]);

  return (
    <div className="body-bg overflow-auto flex-fill">
      <div className="container pt-2">
        <AuthSubHeader />
            {uploadEOBsObject && <EOBsInformation EOPsObject={uploadEOBsObject}/>}
          <div className="mt-3"><FooterText /></div>
        </div>
      </div>
  );
};

export default EOBsDetail;
